import React, { useState, useEffect } from 'react';
import { TextField, Button, Stack, Typography, MenuItem } from '@mui/material';
import { firestore } from '../firebase.config';
import { where, query, collection, getDocs, doc, getDoc, updateDoc } from 'firebase/firestore';
import PageNavBar from '../components/PageNavBar';
import { useNavigate } from 'react-router-dom';
import {
  getUserEmail,
  clearSignInTime,
  clearUserEmail,
  clearUserName,
  clearIsAdmin,
  getIsAdmin,
} from "../utils/sessionCheck";
import { useUserContext } from "../context/UserContext";
import TenantBanner from "../components/TenantBanner";

const AssignCoordinates = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [coordinates, setCoordinates] = useState({ latitude: '', longitude: '' });
  const [radius, setRadius] = useState('');
  const navigate = useNavigate();

  const { userRole, tenantId, selectedTenantId } = useUserContext();

  // Define state and handlers for the AppBar
  const [isAdmin] = useState(true); // or fetch from context/store
  const [uEmail] = useState('user@example.com'); // replace with actual user email
  const [anchor, setAnchor] = useState(null);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchor(null);
  };

  const handleLogout = () => {
    clearUserEmail();
    clearUserName();
    clearSignInTime();
    clearIsAdmin();
    navigate("/");
  };

  const handleSettingsClick = (event) => {
    setSettingsAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setSettingsAnchorEl(null);
  };

  // Fetch users from the database on component mount
  useEffect(() => {
    const tenantFilterID = 
      userRole === "SuperAdmin"
        ? selectedTenantId || sessionStorage.getItem("selectedTenantId")
        : tenantId || sessionStorage.getItem("selectedTenantId");
      //if (!tenantFilterID) return;
      if (!tenantFilterID) {
        console.warn("Missing tenantFilterID");
        return;
      }
    const fetchUsers = async () => {
      const q = query(
        collection(firestore, "Users"),
        where("Is_Active", "==", true),
        where("tenantId", "==", tenantFilterID)
      );

      const usersSnapshot = await getDocs(q);

      const usersList = usersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setUsers(usersList);
    };
    
    fetchUsers();
  }, [userRole, tenantId, selectedTenantId]);

  const handleAssignCoordinates = async (e) => {
    e.preventDefault();
    if (selectedUser && coordinates.latitude && coordinates.longitude && radius) {
      const userDocRef = doc(firestore, 'Users', selectedUser);
      
      // Fetch the user's document
      const userDoc = await getDoc(userDocRef);
      
      if (userDoc.exists()) {
        // Update coordinates and radius if user already exists
        await updateDoc(userDocRef, {
          coordinates: { 
            latitude: parseFloat(coordinates.latitude), 
            longitude: parseFloat(coordinates.longitude), 
            radius: parseFloat(radius) 
          }
        });

        // Alert after successful update
        alert('Coordinates assigned successfully!');
      } else {
        alert('User does not exist.');
        return;
      }
      
      // Reset the form
      setSelectedUser('');
      setCoordinates({ latitude: '', longitude: '' });
      setRadius('');
    } else {
      alert('Please fill in all fields.');
    }
  };

  return (
    <div>
      <PageNavBar title="Assign Coordinates" backTo="/dashboard" />
      <TenantBanner />
      
      <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', mt: 2 }}>Assign Coordinates</Typography>
      <form onSubmit={handleAssignCoordinates}>
        <Stack spacing={2} sx={{ width: '400px', margin: '0 auto', mt: 3 }}>
          <TextField
            select
            label="Select User"
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
            fullWidth
            required
          >
            {users.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.userEmail} {/* Ensure 'userEmail' is a property in your user data */}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Latitude"
            type="number"
            value={coordinates.latitude}
            onChange={(e) => setCoordinates({ ...coordinates, latitude: e.target.value })}
            fullWidth
            required
          />
          <TextField
            label="Longitude"
            type="number"
            value={coordinates.longitude}
            onChange={(e) => setCoordinates({ ...coordinates, longitude: e.target.value })}
            fullWidth
            required
          />
          <TextField
            label="Radius (meters)"
            type="number"
            value={radius}
            onChange={(e) => setRadius(e.target.value)}
            fullWidth
            required
          />
          <Button type="submit" variant="contained" color="primary">
            Assign Coordinates
          </Button>
        </Stack>
      </form>
    </div>
  );
};
export default AssignCoordinates;
